/**
 * User: Keith
 * Author: Faris
 * Date: 6/25/15
 * Time: 9:16 AM
 */

define('app/site',['require','./utils','./router','./form','./models/page','./views/preloader','./views/header','./views/footer','./views/reservation','./views/default','./views/home','./views/split','./views/split','./views/meetings','./views/gallery','./views/map','./views/book_event','./views/book_event','./views/calendar','./views/calendar_details','./views/calendar','./views/split','./views/split','./views/list','./views/longpage','./views/split_mini_slideshow','./views/contact','./views/amenities','./views/iconic_venues'],function (require) {
  var utils = require("./utils");
  var Router = require("./router");
  var Form = require("./form");
  var Page = require("./models/page");
  var Preloader = require("./views/preloader");
  var Header = require("./views/header");
  var Footer = require("./views/footer");
  var Reservation = require("./views/reservation");

  var templates = {
    default: require("./views/default"),
    home: require("./views/home"),
    lofts: require("./views/split"),
    story: require("./views/split"),
    meetings_events: require("./views/meetings"),
    gallery: require("./views/gallery"),
    map: require("./views/map"),
    gravier_street_social_book: require("./views/book_event"),
    book_events: require("./views/book_event"),
    calendar_list: require("./views/calendar"),
    calendar_details: require("./views/calendar_details"),
    calendar: require("./views/calendar"),
    gravier_street_social: require("./views/split"),
    the_story: require("./views/split"),
    neighborhood_details: require("./views/list"),
    utilities: require("./views/longpage"),
    gravier_street_social_idea: require("./views/split_mini_slideshow"),
    contact: require("./views/contact"),
    amenities: require("./views/amenities"),
    iconic_venues: require("./views/iconic_venues")
  };

  return Backbone.View.extend({
    models: {},

    // Event listeners
    events: {
      "click [data-href]": "onClickHref",
      "click .newsletter": "onClickNewsletter",
      "click .scrim": "onClickScrim",
      "keypress #newsletter": "onEnterNewsLetter",
      "keypress #newsletter-mobile": "onEnterNewsLetter",
      "click #newsletterArrow": "onSubmitNewsLetter",
      "click #newsletterArrow-mobile": "onSubmitNewsLetter",
      "click .mobile-icon": "toggleMobileNav",
      "click #menu a": "onClickMenuLink",
      "click #mobile-newsletter-link": "onClickMobileNewsletter",
      "click .mobile-popup-scrim": "onCloseMobileNewsletter",
      "click #newsletter-close": "onCloseMobileNewsletter",
      "touchstart .mobile-popup-scrim": "onCloseMobileNewsletter",
      "touchstart #newsletter-close": "onCloseMobileNewsletter",
      "click #reservation .reserve h4": "onClickReservationTitle",
      "mouseenter #credits": "onOverCredits",
      "mouseleave #credits": "onOutCredits",
      "mouseenter #credits-mobile": "onOverCreditsMobile",
      "mouseleave #credits-mobile": "onOutCreditsMobile"
    },

    header: null,
    footer: null,
    curPage: null,
    newPage: null,

    initialize: function (options) {
      Backbone.View.prototype.initialize.call(this, options);
      _.bindAll(
        this,
        "onClickHref",
        "onResize",
        "onRouteChanged",
        "onFetchedPage",
        "onAssetLoaded",
        "onPageLoaded"
      );

      this.setElement($("body"));

      this.IE = $("html").hasClass("ie8") || $("html").hasClass("ie9");
      this.preserve3d = Modernizr.preserve3d;
      this.preloader = new Preloader({ el: "#PreloaderContainer" });
      this.header = new Header({ el: "header" });
      this.footer = new Footer({ el: "footer" });
      this.router = new Router();
      this.router.on("routeChanged", this.onRouteChanged);

      Backbone.history.start({ pushState: true });

      //TweenMax.to('#Spinner', 1, { alpha: 0, display: 'none' });
      TweenMax.to("#spinnerContainer", 1, { alpha: 0, display: "none" });
      TweenMax.to("#Wrapper", 1, { alpha: 1, visibility: "visible" });

      $(window).resize(this.onResize).resize();

      // Add reservation widget
      this.addReservationWidget("reservation");

      // Mobile nav
      $(window).on("resize", this.checkForMobile);
      this.isMobile = false;

      // Load placeholders for older browsers
      $("input, textarea").placeholder();
    },

    start: function () {
      $("form").each(function () {
        new Form({ el: $(this) });
      });
    },

    onOverCredits: function () {
      $("#credits a").html("IdeaWork");
    },

    onOutCredits: function () {
      $("#credits a").html("credits");
    },

    onOverCreditsMobile: function () {
      $("#credits-mobile").html("IdeaWork");
    },

    onOutCreditsMobile: function () {
      $("#credits-mobile").html("credits");
    },

    onClickHref: function (e) {
      var href = $(e.currentTarget).data("href");
      var target = $(e.currentTarget).data("target");
      var parent = $(e.currentTarget).data("parentid");

      // Check for mobile
      if (parent == "0" && $(window).width() <= 768) {
        var childOpened = $(e.currentTarget).next("ul").is(":visible");
        // Close all children
        $("#menu ul").slideUp();
        // Show current child if it was closed before
        if (!childOpened) {
          $(e.currentTarget).next("ul").slideToggle();
        }
        // Remove and Add this as selected parent
        $(".selectedParent").removeClass("selectedParent");
        $(e.currentTarget).addClass("selectedParent");
      } else {
        // Check if is parent and has active child, then toggle subnav
        if (
          parent == "0" &&
          $(e.currentTarget).closest("li").find(".selectedNav").length
        ) {
          // Just toggle
          $(e.target).next("ul").slideToggle();
        } else {
          // Navigate to page depending on the href provided on this link
          if (typeof href != "undefined" && href != "") {
            if (typeof target != "undefined" && target == "_blank") {
              window.open(href, "_blank");
            } else {
              this.router.navigate(href, { trigger: true });
            }
          }
        }
      }
    },

    onResize: function (e) {
      if (this.curPage) this.curPage.onResize(e);
      if (this.newPage) this.newPage.onResize(e);

      $(".vertical-center").each(function () {
        $(this).css("margin-top", -$(this).outerHeight(true) / 2);
      });
    },

    onRouteChanged: function (path) {
      var path = "/" + path;
      path = path.split("?")[0];

      ga("send", "pageview", path);

      // Update nav menu
      this.updateNavigation(path);

      this.header.close();

      // Check if page is already loaded in model
      if (this.models[path]) {
        this.updatePage(this.models[path]);
      } else {
        // Not in model, so show transition, load/get page and call onFetchedPage when complete
        this.preloader.transitionIn();

        var page = new Page({ PATH: path });
        page.fetch({ success: this.onFetchedPage });
      }
    },

    onFetchedPage: function (model) {
      if (model.get("SUCCESS")) {
        //store this page model
        this.models[model.get("PATH")] = model;

        //update the site page
        this.updatePage(model);
      } else {
        if (model.get("REDIRECT") != "") {
          this.router.navigate(model.get("REDIRECT"), { trigger: true });
        } else {
          this.router.navigate("/", { trigger: true });
        }
      }
    },

    updatePage: function (model) {
      if (model.get("LINKSWITCH") && model.get("LINK") != "") {
        //is a redirect
        var link = model.get("LINK");
        if (
          link.indexOf(".pdf") >= 0 ||
          link.indexOf(".jpg") >= 0 ||
          link.indexOf(".gif") >= 0 ||
          link.indexOf(".png") >= 0
        ) {
          window.open(model.get("LINK"), "_blank");
          Backbone.history.back();
        } else {
          this.router.navigate(model.get("LINK"), {
            trigger: true,
            replace: true
          });
          this.updateNavigation(model.get("LINK"));
        }

        return false;
      } else if (model.get("TEMPLATE") == "calendar_details") {
        this.newPage = new templates[model.get("TEMPLATE")]({ model: model });
        //update the page title
        if (model.get("PAGETITLE")) {
          document.title = model.get("PAGETITLE");
        }

        this.newPage.on("assetLoaded", this.onAssetLoaded);
        this.newPage.on("loaded", this.onPageLoaded);
        this.newPage.preload();
      } else if (model.get("ALLOWEDIT")) {
        //page is uneditable (should be unbrowsable too)
        if (templates[model.get("TEMPLATE")]) {
          this.newPage = new templates[model.get("TEMPLATE")]({ model: model });
        } else {
          this.newPage = new templates["default"]({ model: model });
        }

        //update the page title
        if (model.get("PAGETITLE")) {
          document.title = model.get("PAGETITLE");
        }

        this.newPage.on("assetLoaded", this.onAssetLoaded);
        this.newPage.on("loaded", this.onPageLoaded);
        this.newPage.preload();
      } else {
        var children = model.get("CHILDREN");
        if (children && children.length) {
          this.router.navigate(model.get("CHILDREN")[0].PATH, {
            trigger: true,
            replace: true
          });
        } else {
          this.router.navigate("/", { trigger: true });
        }
      }
    },

    onAssetLoaded: function (percentage) {
      this.preloader.update(percentage);
    },

    onPageLoaded: function () {
      //transition out current page
      if (this.curPage) {
        this.curPage.transitionOut(this.newPage);
      } else {
        //cur page is null, so this is the first page, show the nav and footer
        //this.header.transitionIn();
      }

      $("#Content").prepend(this.newPage.render());
      this.newPage.transitionIn(this.curPage);
      this.curPage = this.newPage;

      this.header.update(this.curPage.model);
      $("body")
        .removeClass()
        .addClass("template-" + this.curPage.model.get("TEMPLATE"));

      $("body").scrollTop(0);

      $(window).resize();
    },

    onEnterNewsLetter: function (e) {
      // Detect enter key
      if (e.keyCode == 13) {
        this.onSubmitNewsLetter(e);
      }
    },

    onSubmitNewsLetter: function (e) {
      var target = $(e.target).closest("div");
      var placeholder = target.find(".newsletter").attr("placeholder");
      var email = target.find(".newsletter").val();

      // Validate email through regex
      var valid = true;
      var re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/gim;
      if (email == "" || !re.test(email)) {
        valid = false;
      }

      // Check for valid email
      if (valid) {
        // Send to script
        $.post(
          "/library/ajax/submit_newsletter.cfm",
          "email=" + email,
          function (result) {
            result = jQuery.parseJSON(result);
            if (result.success) {
              // Remove invalid field if any
              target.find(".newsletter").removeClass("invalidField");

              // Add in placeholder with thank you message
              target
                .find(".newsletter")
                .val("")
                .attr("placeholder", "thank you");
            } else {
              // Add in placeholder with error message
              target
                .find(".newsletter")
                .val("")
                .attr("placeholder", result.message);
            }
          }
        );
      } else {
        // Alert invalid
        target.find(".newsletter").addClass("invalidField");
        target.find(".newsletter").val("");
        target.find(".newsletter").attr("placeholder", "invalid email");

        // Change color back to normal
        setTimeout(function () {
          target.find(".newsletter").removeClass("invalidField");
          target.find(".newsletter").attr("placeholder", "newsletter sign up");
        }, 7000);
      }
    },
    updateNavigation: function (path) {
      if (path.indexOf("/gravier-street-social/calendar") != -1)
        path = "/gravier-street-social/calendar";

      // Remove open from mobile nav icon
      $(".mobile-icon").removeClass("open");

      // Remove any current parent classes
      $(".selectedParent").removeClass("selectedParent");

      // Update navigation marker
      $("#menu a").removeClass("selectedNav"); // Remove selectedNav class from all links
      var link = $('#menu a[data-href="' + path + '"]'); // Get current link
      link.last().addClass("selectedNav"); // Add selected to current link

      // Add to parent
      link
        .closest('li[data-parent-id="0"]')
        .children("a")
        .addClass("selectedParent");

      // Open sub menu if it has one
      if (link.closest("li").children("ul")) {
        link.closest("li").children("ul").slideDown();
      }

      // Close siblings
      link.closest("li").siblings("li").find("ul").slideUp();

      // Traverse parents and expand them
      var haveParent = true;
      do {
        var parent = link.parent().closest("ul"); // Closest UL traversing UP
        // If there is a parent and this UL's ID!=menu (top of list)
        if (parent.length && parent.id != "menu") {
          parent.slideDown(); // Expand this parent list
          link = parent; //  Point to next list
        } else {
          haveParent = false;
        }
      } while (haveParent);
    },

    addReservationWidget: function (id) {
      var reservation = new Reservation();
      // Add to container with id
      $("#" + id).html(reservation.$el);
    },

    /*
     * Checks if we're in mobile (<768), if so, hide the nav
     */
    checkForMobile: function () {
      if ($(window).width() <= 768) {
        this.isMobile = true;
        $("header nav").hide();
        $("header nav").mCustomScrollbar();
      } else {
        this.isMobile = false;
        $("header nav").show();
        $("header nav").mCustomScrollbar("destroy");
      }
    },

    toggleMobileNav: function () {
      $("header nav").toggle();
      if ($("header nav").is(":visible")) {
        $(".mobile-icon").addClass("open");
      } else {
        $(".mobile-icon").removeClass("open");
      }
    },

    onClickMenuLink: function (e) {
      if ($(window).width() <= 768) {
        if ($(e.target).data("parentid") != "0") {
          $("header nav").hide();
          $(".mobile-icon").removeClass("open");
        }
      }
    },

    onClickMobileNewsletter: function (e) {
      $(".mobile-popup").fadeIn();
    },

    onCloseMobileNewsletter: function (e) {
      $(".mobile-popup").fadeOut();
    },

    // Reservation box has been collapsed, make it a button
    onClickReservationTitle: function (e) {
      if ($(window).height() <= 650) {
        window.open(
          "https://reservations.ihotelier.com/istay.cfm?HotelID=3546",
          "_blank"
        );
      }
    }
  });

  return Site;
});

